import { render, staticRenderFns } from "./Registrarse.vue?vue&type=template&id=4d76328c"
import script from "./Registrarse.vue?vue&type=script&lang=js"
export * from "./Registrarse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports